var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("common-page", {
    ref: "commonPage",
    attrs: {
      "page-type": "hdPage",
      "bg-path": _vm.bgPath,
      "web-path": _vm.webPath,
      columns: _vm.columns,
      "search-items": _vm.searchItems,
      "form-items": _vm.formItems,
      "d-table-config": _vm.dTableConfig,
    },
    scopedSlots: _vm._u([
      {
        key: "form-bottom",
        fn: function () {
          return [_c("d-table")]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }